import React, { useState, useEffect } from 'react';
import { Container, Typography, Card, CardContent, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Box, AppBar, Toolbar } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie , Bar} from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const Bookprintcalc: React.FC = () => {
  // --- State for Inputs ---
  const [numCopies, setNumCopies] = useState(1000);
  const [isColor, setIsColor] = useState(false);
  const [numPages, setNumPages] = useState(204);
  const [paperGrams, setPaperGrams] = useState(70);
  const [pricePerRim, setPricePerRim] = useState(34000);  
  const [laminationCostPerCopy, setLaminationCostPerCopy] = useState(80);
  const [cartonCost, setCartonCost] = useState(1500);
  const [cartonCapacity, setCartonCapacity] = useState(25);  //vary carton capacity based on paper grams
  const [isbnCost, setIsbnCost] = useState(10000); 
  const [miscCost, setMiscCost] = useState(15000);
  const [computerCostPerSection, setComputerCostPerSection] = useState(700);
  const [editorialFeePerPage, setEditorialFeePerPage] = useState(450);
  const [bindingCostPerCopy, setBindingCostPerCopy] = useState(0);
  const [ctpBwCost] = useState(4500);
  const [ctpColorCost] = useState(15000);
  const [impressionBwCost] = useState(4500);
  const [impressionColorCost] = useState(20000);
  const [coverRimPrice , setCoverRimPrice] = useState(35000);  //vary cover price based on paper grams

  // --- State for Calculated Costs ---
  const [totalCost, setTotalCost] = useState(0);
  const [wastePaper, setWastePaper] = useState(200);

  const [sellingPrice, setSellingPrice] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [costBreakdown, setCostBreakdown] = useState<Record<string, number>>({});

  const formatCurrency = (value: number) => new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(value);

  useEffect(() => {
    const calculateCosts = () => {
        const sections = Math.ceil(numPages / 8);
        const baseCtpCost = isColor ? ctpColorCost : ctpBwCost;
        const ctpCost = baseCtpCost *  sections ;//Math.pow(2, Math.floor(numCopies / 5000));
        const baseImpressionCost = isColor ? impressionColorCost : impressionBwCost;
        const impressionCost = baseImpressionCost * sections ;
        // Math.pow(2, Math.floor(numCopies / 1000));
        const computerCost = sections * computerCostPerSection;
        const laminationCost = laminationCostPerCopy * numCopies;
        const CartonCap =  (10000 / numPages )
        setCartonCapacity(CartonCap)
        const packagingCost = Math.ceil( numCopies / CartonCap )* cartonCost;
        console.log('Paacking Cost : ' + numPages)
        
        //Math.ceil(numCopies / cartonCapacity) * cartonCost;
        const coverCost = (((numCopies + 200) / 500)   * coverRimPrice) + 35000;
        const paperCost = (((sections / 2) * (numCopies + Number(wastePaper)) )/ 1000) * pricePerRim;  // vary 200 if necessary

//         const sectionsNum = Number(sections) || 0;
// const numCopiesNum = Number(numCopies) || 0;
// const wastePaperNum = Number(wastePaper) || 0;
// const pricePerRimNum = Number(pricePerRim) || 0;


        
// const paperCost = ((((numPages * (numCopies + wastePaperNum)) / 16) )/ 1000) * pricePerRimNum;  // vary 200 if necessary

        console.log("Paper Cost : " + paperCost)
        console.log("wastePaper : " + wastePaper)
        const editorialFee = numPages * editorialFeePerPage;
       const  bindingCostPerCopyx = ((sections/2) * 2000 * 5) / numCopies; // 
       setBindingCostPerCopy(bindingCostPerCopyx) //Example: 2000 per section for 5 sections
        const bindingCost = bindingCostPerCopyx * numCopies;
console.log("Binding Cost Per Copy: ", bindingCostPerCopy);
        const breakdown = {
            'CTP': ctpCost,
            'Impression': impressionCost,
            'Miscellaneous': miscCost,
            'Computer': computerCost,
            'ISBN': isbnCost,
            'Lamination': laminationCost,
            'Packaging': packagingCost,
            'Cover': coverCost,
            'Paper': paperCost,
            'Editorial': editorialFee,
            'Binding': bindingCost,
        };

        const finalCost = Object.values(breakdown).reduce((acc, val) => acc + val, 0);
        const unitCost = finalCost > 0 && numCopies > 0 ? finalCost / numCopies : 0;
        const finalSellingPrice = unitCost * 1.3;

        setCostBreakdown(breakdown);
        setTotalCost(finalCost);
        setUnitPrice(unitCost);
        setSellingPrice(finalSellingPrice);
    };

    calculateCosts();
  }, [numCopies, isColor, numPages, paperGrams, pricePerRim, laminationCostPerCopy, cartonCost, cartonCapacity, isbnCost, miscCost, computerCostPerSection, editorialFeePerPage, bindingCostPerCopy, ctpBwCost, ctpColorCost, impressionBwCost, impressionColorCost, wastePaper,coverRimPrice]);
  
  const chartData = {
    labels: Object.keys(costBreakdown),
    datasets: [
      {
        label: 'Cost Breakdown',
        data: Object.values(costBreakdown),
        backgroundColor: [
          'rgba(255, 99, 132, 0.7)', 'rgba(54, 162, 235, 0.7)', 'rgba(255, 206, 86, 0.7)',
          'rgba(75, 192, 192, 0.7)', 'rgba(153, 102, 255, 0.7)', 'rgba(255, 159, 64, 0.7)',
          'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)',
          'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)',
          'rgba(255, 99, 132, 0.8)', 'rgba(54, 162, 235, 0.8)', 'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)', 'rgba(153, 102, 255, 0.8)',
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Book Printing Cost Calculator
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={5}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom>
                  Parameters
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Number of Copies" type="number" value={numCopies} onChange={e => setNumCopies(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><FormControl fullWidth variant="outlined"><InputLabel>Print Type</InputLabel><Select value={isColor.toString()} onChange={e => setIsColor(e.target.value === 'true')} label="Print Type"><MenuItem value="false">Black & White</MenuItem><MenuItem value="true">Coloured</MenuItem></Select></FormControl></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Number of Pages" type="number" value={numPages} onChange={e => setNumPages(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Paper Grams" type="number" value={paperGrams} onChange={e => setPaperGrams(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Price per Rim" type="number" value={pricePerRim} onChange={e => setPricePerRim(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Lamination Cost/Copy" type="number" value={laminationCostPerCopy} onChange={e => setLaminationCostPerCopy(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Carton Cost" type="number" value={cartonCost} onChange={e => setCartonCost(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="ISBN Cost" type="number" value={isbnCost} onChange={e => setIsbnCost(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Misc. Cost" type="number" value={miscCost} onChange={e => setMiscCost(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="Editorial Fee/Page" type="number" value={editorialFeePerPage} onChange={e => setEditorialFeePerPage(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
                  <Grid item xs={12} sm={6}><TextField fullWidth label="cartonCapacity " type="number" value={cartonCapacity} onChange={e => setCartonCapacity(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>

    <Grid item xs={12} sm={6}><TextField fullWidth label="Binding Cost/Copy" type="number" value={bindingCostPerCopy} onChange={e => setBindingCostPerCopy(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>


  <Grid item xs={12} sm={6}><TextField fullWidth label="coverRimPrice" type="number" value={coverRimPrice} onChange={e => setCoverRimPrice(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>


  <Grid item xs={12} sm={6}><TextField fullWidth label="Waste Paper" type="number" value={wastePaper} onInput={e => setWastePaper(parseInt(e.target.value, 10) || 0)} variant="outlined" /></Grid>
 



                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={7}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom>Cost Analysis</Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} lg={6}>
                    {Object.entries(costBreakdown).map(([key, value]) => (
                      <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                        <Typography variant="body2">{key}</Typography>
                        <Typography variant="body2"><b>{formatCurrency(value)}</b></Typography>
                      </Box>
                    ))}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1, mt: 1, borderTop: '1px solid #ddd' }}>
                      <Typography variant="body1"><b>Total Cost</b></Typography>
                      <Typography variant="body1"><b>{formatCurrency(totalCost)}</b></Typography>
                    </Box>
                     <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                      <Typography variant="body2">Cost Price / Unit</Typography>
                      <Typography variant="body2"><b>{formatCurrency(unitPrice)}</b></Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, color: 'primary.main' }}>
                      <Typography variant="h6">Selling Price / Unit</Typography>
                      <Typography variant="h6"><b>{formatCurrency(sellingPrice)}</b></Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 250 }}>
                    <Pie data={chartData} options={{ responsive: true, plugins: { legend: { position: 'top' } } }} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Bookprintcalc;
